import { createTheme } from "@mui/material/styles";

// Define your design tokens here
const theme = createTheme({
  palette: {
    primary: {
      main: "#3a86ff",    // brand blue
    },
    secondary: {
      main: "#ff006e",    // accent pink
    },
    error: {
      main: "#d32f2f",
    },
    background: {
      default: "#f9f9f9",
      paper: "#ffffff",
    },
    text: {
      primary: "#333333",
      secondary: "#666666",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
    },
  },
  spacing: 8, // default spacing unit (8px)
});

export default theme;
